import React from "react";

const Bg = () => {
  return (
    <div className="c_bg">
      <img
        alt=""
        src="https://ptl-ru-cdn.tanki.su/dcont/fb/image/daily-rewards_bg.jpg"
      />
    </div>
  );
};

export default Bg;
